import React, { useCallback } from 'react';
import { LabelSeriesPoint } from 'generated/signals-graphql';
import SimpleMap from './Map';
import ReactTooltip from 'react-tooltip';

interface Props {
  typeOfDistribution: string;
  data: LabelSeriesPoint[];
}

const ChoroplethMapWithTooltip: React.FC<Props> = ({ data, typeOfDistribution }) => {
  const [content, setContent] = React.useState<string>('');

  const setTooltip = useCallback(
    (data: string) => {
      setContent(data);
    },
    [setContent]
  );

  return data ? (
    <>
      <ReactTooltip>{content}</ReactTooltip>
      <SimpleMap
        data={data}
        typeOfDistribution={typeOfDistribution}
        setTooltipContent={setTooltip}
      />
    </>
  ) : null;
};

export default ChoroplethMapWithTooltip;
